"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HLQATasksBulkEditModal = void 0;
const react_1 = __importStar(require("react"));
const graphql_1 = require("../../../../../__generated__/graphql");
const ui_components_1 = require("@groupby/ui-components");
const ExpandMoreRounded_1 = __importDefault(require("@mui/icons-material/ExpandMoreRounded"));
const hlqa_tasks_bulk_edit_modal_styles_1 = require("./hlqa-tasks-bulk-edit-modal.styles");
const client_1 = require("../../client");
const constants_1 = require("../../hooks/table-config/constants");
const localization_1 = require("../../../../../localization");
const INITIAL_DRAFT = {
    priority: '',
    status: '',
    assignedTo: '',
};
const HLQATasksBulkEditModal = ({ projectId, open, onClose, onSave, isSaving = false, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const [draft, setDraft] = (0, react_1.useState)(INITIAL_DRAFT);
    const { collaboratorOptions, loadCollaboratorOptions, isLoading: isCollaboratorsLoading, } = (0, client_1.useGetProjectCollaborators)({ projectId });
    (0, react_1.useEffect)(() => {
        if (!open) {
            setDraft(INITIAL_DRAFT);
        }
    }, [open]);
    (0, react_1.useEffect)(() => {
        if (!open || !projectId || isCollaboratorsLoading || collaboratorOptions.length > 0) {
            return;
        }
        void loadCollaboratorOptions();
    }, [
        collaboratorOptions.length,
        isCollaboratorsLoading,
        loadCollaboratorOptions,
        open,
        projectId,
    ]);
    const priorityOptions = (0, react_1.useMemo)(() => ([
        {
            id: 'priority_leave_unchanged',
            label: t({ key: 'LEAVE_UNCHANGED' }),
            value: '',
        },
        ...Object.values(graphql_1.PriorityTasksPriority).map((priority) => ({
            id: `priority_${priority}`,
            label: `${priority} - ${t({ key: constants_1.PRIORITY_TO_LOCALIZATION_MESSAGE_KEY[priority] })}`,
            value: priority,
        })),
    ]), [t]);
    const assigneeOptions = (0, react_1.useMemo)(() => ([
        {
            id: 'leave_unchanged',
            label: t({ key: 'LEAVE_UNCHANGED' }),
            value: '',
        },
        ...collaboratorOptions,
    ]), [collaboratorOptions, t]);
    const statusOptions = (0, react_1.useMemo)(() => ([
        {
            id: 'status_leave_unchanged',
            label: t({ key: 'LEAVE_UNCHANGED' }),
            value: '',
        },
        ...Object.values(graphql_1.PriorityTaskStatus)
            .filter((status) => status !== graphql_1.PriorityTaskStatus.InProgress)
            .map((status) => ({
            id: `status_${status}`,
            label: t({ key: constants_1.STATUS_TO_LOCALIZATION_MESSAGE_KEY[status] }),
            value: status,
        })),
    ]), [t]);
    const hasPriorityChange = draft.priority !== '';
    const hasStatusChange = draft.status !== '';
    const hasAssigneeChange = draft.assignedTo !== '';
    const isSaveDisabled = (0, react_1.useMemo)(() => isSaving || (!hasPriorityChange && !hasStatusChange && !hasAssigneeChange), [hasAssigneeChange, hasPriorityChange, hasStatusChange, isSaving]);
    const handleSave = (0, react_1.useCallback)(() => {
        const values = Object.assign(Object.assign(Object.assign({}, (draft.priority ? { priority: draft.priority } : {})), (draft.status ? { status: draft.status } : {})), (draft.assignedTo ? { assignedTo: draft.assignedTo } : {}));
        void onSave(values);
    }, [draft.assignedTo, draft.priority, draft.status, onSave]);
    if (!open) {
        return null;
    }
    return (react_1.default.createElement(ui_components_1.Dialog, { open: true, maxWidth: "sm", title: t({ key: 'HLQA_EDIT_TASKS' }), onClose: onClose, proceedButtonProps: {
            title: t({ key: 'SAVE' }),
            onClick: handleSave,
            disabled: isSaveDisabled,
        }, cancelButtonProps: {
            title: t({ key: 'CANCEL' }),
            onClick: onClose,
            disabled: isSaving,
        } }, react_1.default.createElement(hlqa_tasks_bulk_edit_modal_styles_1.StyledHLQATasksBulkEditModalContent, null, react_1.default.createElement(ui_components_1.Typography, { color: "textSecondary", variant: "body2" }, t({ key: 'BULK_EDIT_VALUES_DIALOG_PLACEHOLDER' })), react_1.default.createElement(hlqa_tasks_bulk_edit_modal_styles_1.StyledHLQATasksBulkEditModalFields, null, react_1.default.createElement("div", null, react_1.default.createElement(ui_components_1.Typography, { variant: "body2" }, t({ key: 'HLQA_TABLE_COLUMN_PRIORITY' })), react_1.default.createElement(hlqa_tasks_bulk_edit_modal_styles_1.StyledHLQATasksBulkEditModalAutocomplete, { options: priorityOptions, selected: draft.priority, placeholder: t({ key: 'LEAVE_UNCHANGED' }), disableClearable: true, forcePopupIcon: true, popupIcon: react_1.default.createElement(ExpandMoreRounded_1.default, { fontSize: "small" }), InputProps: { readOnly: true }, onChange: (nextPriority) => setDraft((prev) => (Object.assign(Object.assign({}, prev), { priority: nextPriority }))) })), react_1.default.createElement("div", null, react_1.default.createElement(ui_components_1.Typography, { variant: "body2" }, t({ key: 'HLQA_TABLE_COLUMN_STATUS' })), react_1.default.createElement(hlqa_tasks_bulk_edit_modal_styles_1.StyledHLQATasksBulkEditModalAutocomplete, { options: statusOptions, selected: draft.status, placeholder: t({ key: 'LEAVE_UNCHANGED' }), disableClearable: true, forcePopupIcon: true, popupIcon: react_1.default.createElement(ExpandMoreRounded_1.default, { fontSize: "small" }), InputProps: { readOnly: true }, onChange: (nextStatus) => setDraft((prev) => (Object.assign(Object.assign({}, prev), { status: nextStatus }))) })), react_1.default.createElement("div", null, react_1.default.createElement(ui_components_1.Typography, { variant: "body2" }, t({ key: 'HLQA_TABLE_COLUMN_ASSIGNEE' })), react_1.default.createElement(hlqa_tasks_bulk_edit_modal_styles_1.StyledHLQATasksBulkEditModalAutocomplete, { options: assigneeOptions, selected: draft.assignedTo, placeholder: t({ key: 'LEAVE_UNCHANGED' }), isLoading: isCollaboratorsLoading, disableClearable: true, forcePopupIcon: true, popupIcon: react_1.default.createElement(ExpandMoreRounded_1.default, { fontSize: "small" }), InputProps: { readOnly: true }, onChange: (nextAssignee) => setDraft((prev) => (Object.assign(Object.assign({}, prev), { assignedTo: nextAssignee }))) }))))));
};
exports.HLQATasksBulkEditModal = HLQATasksBulkEditModal;
